import React from 'react';
import Topbar from "../Topbar";
import { useState, useEffect  } from 'react';
import Sidebar from "../Sidebar";
import moment from 'moment';
import axiosInstance from '../../helpers/axios';
import DatePicker from "react-multi-date-picker";
import calender from "../../assets/images/calender.png";
import download from "../../assets/images/download.png";

export default function WrittenOffLoans() {
    const user = sessionStorage.getItem('user');
    const [isOpen,setIsOpen]=useState(true) 
    const [ClosedstartDate,setClosedStartDateFrom] = useState()
    const [ClosedendDate,setclosedEndDateTo] = useState()
    const [WrittenOffData, setWrittenOffData] = useState()
    // const [WrittenOffLoans, setWrittenOffLoans] = useState();
    
  useEffect(() => {


    axiosInstance.get('/analytics/get-Writtenoff', {
      headers: {
        Authorization: `Bearer ${user}`,
      },
    //   params: queryParams 
    })
    .then((res) => {   
      console.log(res?.data?.data, 'data');
      setWrittenOffData(res?.data?.data)
    })
    .catch((error) => {
      console.log(error);
    });

  }, []); 


  
  function formatNumberWithCommas(number) {
    return number?.toLocaleString('en-IN'); 
  }

  const fetchingWritteOffdData = ()=>{
        
    let queryParams = {}
    if(ClosedstartDate && ClosedendDate){
      const formattedStartDate = moment(ClosedstartDate, 'DD MMM YYYY').format('YYYY-MM-DD');
      const formattedEndDate = moment(ClosedendDate, 'DD MMM YYYY').format('YYYY-MM-DD') + " 23:59:59";

    queryParams.startDate = formattedStartDate;
    queryParams.endDate = formattedEndDate;
    }
    console.log(queryParams,'queryParams')
   

    axiosInstance.get('/analytics/get-Writtenoff', {
        params: queryParams,
        headers: {
          Authorization: `Bearer ${user}`,
        }
      })
      .then((res) => {   
        console.log(res?.data?.data, 'data');
        setWrittenOffData(res?.data?.data)
      })
      .catch((error) => {
        console.log(error);
      });
   }



   const handleDownloadList=()=>{
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = String(currentDate.getFullYear());
    const formattedDate = `${day}-${month}-${year}`;
    document.getElementById("downloadButton").disabled=true;
    document.getElementById("downloadButton").innerText="Wait....";
    document.getElementById("downloadButton").style.backgroundColor="#D22129";
    document.getElementById("downloadButton").style.color= "white";
    document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
    document.getElementById("downloadButton").style.fontSize= "15px";
    document.getElementById("downloadButton").style.width= "130px";
    document.getElementById("downloadButton").style.cursor= "pointer";
    document.getElementById("downloadButton").style.height= "34px";
    document.getElementById("downloadButton").style.borderRadius= "5px";
    document.getElementById("downloadButton").style.textAlign= "center";
    document.getElementById("downloadButton").style.backgroundImage = "none"


    const downloadTemplateUrl=`/excel/AllWrittenOffloans `
    
    let queryParams = {}
    if(ClosedstartDate && ClosedendDate){
      const formattedStartDate = moment(ClosedstartDate, 'DD MMM YYYY').format('YYYY-MM-DD');
      const formattedEndDate = moment(ClosedendDate, 'DD MMM YYYY').format('YYYY-MM-DD') + " 23:59:59";

    queryParams.startDate = formattedStartDate;
    queryParams.endDate = formattedEndDate;
    }
    console.log(queryParams,'queryParams')
    
    
    axiosInstance.get("/excel/AllWrittenOffloans", {
      params: queryParams,
      responseType: 'arraybuffer',
      headers: {
          Authorization: `Bearer ${user}`
      }
  }).then((res)=>{
    setTimeout(() => {
      document.getElementById("downloadButton").disabled=false
      document.getElementById("downloadButton").innerText="Export";
      document.getElementById("downloadButton").style.paddingLeft = "30px";
      document.getElementById("downloadButton").style.backgroundColor="#D22129";
      document.getElementById("downloadButton").style.color= "white";
      document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
      document.getElementById("downloadButton").style.fontSize= "15px";
      document.getElementById("downloadButton").style.width= "130px";
      document.getElementById("downloadButton").style.cursor= "pointer";
      document.getElementById("downloadButton").style.height= "34px";
      document.getElementById("downloadButton").style.borderRadius= "5px";
      document.getElementById("downloadButton").style.textAlign= "center";
      // document.getElementById("downloadButton").style.marginLeft= "30px";
      document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
      document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
      // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
      document.getElementById("downloadButton").style.backgroundSize  ='15px' 
      document.getElementById("downloadButton").style.backgroundPosition  ='10px 10px'

    }, 2000);
    const blob = new Blob([res.data], { type: "application/xlsx", });
    const url= window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href =url
    link.download = `${formattedDate}.xlsx`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  }
    
  ).catch((error)=>{
    alert("Error Downloading")
    document.getElementById("downloadButton").innerText="Error..";
    document.getElementById("downloadButton").style.backgroundColor="#D22129";
    document.getElementById("downloadButton").disabled=false
      document.getElementById("downloadButton").style.paddingLeft = "30px";
      document.getElementById("downloadButton").style.backgroundColor="#D22129";
      document.getElementById("downloadButton").style.color= "white";
      document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
      document.getElementById("downloadButton").style.fontSize= "15px";
      document.getElementById("downloadButton").style.width= "130px";
      document.getElementById("downloadButton").style.cursor= "pointer";
      document.getElementById("downloadButton").style.height= "34px";
      document.getElementById("downloadButton").style.borderRadius= "5px";
      document.getElementById("downloadButton").style.textAlign= "center";
      // document.getElementById("downloadButton").style.marginLeft= "30px";
      document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
      document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
      // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
      document.getElementById("downloadButton").style.backgroundSize  ='15px' 
      document.getElementById("downloadButton").style.backgroundPosition  ='10px 10px'
    setTimeout(() => {
      document.getElementById("downloadButton").disabled=false
      document.getElementById("downloadButton").innerText="Export";
      // document.getElementById("downloadButton").style.paddingLeft = "30px";
      document.getElementById("downloadButton").style.backgroundColor="#D22129";
      document.getElementById("downloadButton").style.color= "white";
      document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
      document.getElementById("downloadButton").style.fontSize= "15px";
      document.getElementById("downloadButton").style.width= "130px";
      document.getElementById("downloadButton").style.cursor= "pointer";
      document.getElementById("downloadButton").style.height= "34px";
      document.getElementById("downloadButton").style.borderRadius= "5px";
      document.getElementById("downloadButton").style.textAlign= "center";
      // document.getElementById("downloadButton").style.marginLeft= "30px";
      document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
      document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
      // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
      document.getElementById("downloadButton").style.backgroundSize  ='20px' 
      document.getElementById("downloadButton").style.backgroundPosition  ='15px 10px'
    }, 1000);
  })
  } 



        
  return (
    <div style={{display:'flex',width:"100%",backgroundColor:'white',height:'130%'}}>
        <Sidebar isOpenSidebar={isOpen} handler={setIsOpen}/>
        <div style={{width:isOpen?'80%':'100%',marginLeft:isOpen?"20%":'0%',padding:'10px'}}>
        <Topbar/>
        <p style={{textAlign:"center",fontFamily:'Inter-Medium',color:'#667085',fontSize:'25px'}}>WrittenOffLoans </p>
        
        <div style={{ display: 'flex' }}>

        <div style={{ height:'30px',width:'15em', borderRadius: '20px',marginRight:"60px",marginTop:'-2px'}}>
        <DatePicker
        style={{ height:'33px', BorderRadius: '5px',padding: '2px', backgroundRepeat: 'no-repeat',
        backgroundPosition: '5px center',
        backgroundSize: '15px 15px', backgroundImage: `url(${calender})`, paddingLeft: '30px',fontSize:"14px", border:'1px solid #ccc',fontWeight:"normal", border:'1px solid #ccc'}}
        placeholder="Select date range"
        allowClear={true}
        format="DD MMM YYYY"
        onChange={(dates, dateStrings) => {
        console.log("dateStrings:", dateStrings);

          
        setClosedStartDateFrom(dateStrings?.validatedValue[0])
        setclosedEndDateTo(dateStrings?.validatedValue[1])
        }}
        range
        />
        </div>

        <div > 
        <button style={{display: 'flex', alignItems: 'center',width:'130px',backgroundColor:'#D22129',height:'34px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter-Medium",paddingLeft:'10px'}}
        onClick={() => fetchingWritteOffdData()}
        >
        Search Results
        </button>
        </div>

        <div style={{marginLeft:'40px'}}>
        <div style={{backgroundColor:'#D22129',display: 'flex', alignItems: 'center',width:'130px',height:'34px',borderStyle:'none',borderRadius:"5px",fontFamily:"Inter-Medium",paddingLeft:'10px',justifyContent:'space-around',cursor:'pointer',marginRight:'20px'}}
        id="downloadButton"   onClick={() => handleDownloadList()} >

        <img src={download} style={{height:'20px',marginLeft:'8px'}}/> 
        <span style={{fontFamily:"Inter-Medium",color:'white',paddingRight:"15px"}}>Export</span>

        </div></div>


        </div>

        <table className='tables' style={{marginRight:'10px',marginTop:'30px'}}>
          <thead className='table-heading'>
          
            <tr>
      <th style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'left'  }}>Loan ID</th>
      <th style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'left' }}>Loan Amount</th>
      <th style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'left'}}>Paid Amount</th>
      <th style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'left' }}>Outstanding</th>
      <th style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'left' }}>Disbursed Date</th>
      <th style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'left' }}>WrtOff Date</th>
      <th style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'left' }}>EMIs</th>
      <th style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'left' }}>Status</th>
    </tr>
         
          </thead>
          
          <tbody className='table-body'>
           
            {WrittenOffData?.map((item, index) => (
              <tr className="table-row" key={index} style={{ lineHeight:"25px"}}>
                <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '10px' }}>{item.legacy_loan_id}</td>
                <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>₹{formatNumberWithCommas(Math.round(item.loan_amount))}</td>
                <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>₹{formatNumberWithCommas(Math.round(item.repaid_amount))}</td>
                <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>₹{formatNumberWithCommas(Math.round(item.remaining_amount))}</td>
                <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '11em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.disbursement_date}</td>
                <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '11em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.updated_at}</td>
                <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '8em', fontFamily: "Inter-Medium", color: '#667085'}}>{item.emi_paid_count}/{item.tenure}</td>
                <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>  {item.loan_Status}</td>
              </tr>
               ))}
          </tbody>
        </table>
    </div>
    </div>
  )
}
